export const arrayIntersection = (array1, array2) => {
    if (array1 && array2) return array1.filter((x) => array2.includes(x));
    return [];
};
